<div class="interactions-dialog-component gap-16" fxLayout="column">
    <div
        fxLayout="row"
        class="interactions-dialog-component__header"
        fxLayoutAlign="space-between center"
    >
        <h1 class="text-16-semi-bold color-text-primary">Interações</h1>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>
    <p class="text-14-semi-bold color-text-hint">
        {{ data.visualization.props.name }}
    </p>
    <div
        class="interactions-dialog-component__section"
        fxFlex
        fxLayout="column"
    >
        <div
            class="interactions-dialog-component__section__box dsn-scrollbar overflow-y scroll-secondary"
            fxFlex
        >
            <ul class="gap-16" fxLayout="column">
                @for (
                    interaction of data.visualization.postsLike;
                    track interaction.props._id
                ) {
                    <li
                        fxLayout="column"
                        fxLayout="space-between center"
                        class="gap-12"
                    >
                        <div
                            fxLayout="row"
                            fxLayout="none center"
                            class="gap-12"
                        >
                            <span
                                class="interactions-dialog-component-icon {{
                                    interaction.props.comment.optionLike
                                }}"
                                fxLayout="column"
                                fxLayoutAlign="center center"
                                ><i
                                    class="{{
                                        interaction.interactionIconStatus
                                    }}"
                                ></i
                            ></span>
                            <span
                                class="text-14-semi-bold color-text-primary"
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                >{{ interaction.firstName }}
                            </span>
                        </div>
                        @if (interaction?.props?.comment?.msg) {
                            <div
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                class="gap-12"
                            >
                                <div
                                    class="interaction-dialog-component__dvider-vertical"
                                ></div>
                                <dsn-chips
                                    [label]="interaction?.props?.comment?.msg"
                                    [selected]="true"
                                ></dsn-chips>
                            </div>
                        }
                    </li>
                }
            </ul>
        </div>
    </div>
</div>
